
export default function Loader(){
    
  return (
    <>
      <div className="row mt-5">
        <div className="col-1">
        </div>
        <div className="col-3">
          <div className="loader m-4"></div>
          <p className="my-3 mx-2 ps-1">Загрузка...</p>
        </div>
        <div className="col-8">
        </div> 
      </div>
    </>
  )
}